// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"406":"ab309b28","453":"258b012d","830":"f5073339"}[chunkId] + ".chunk.js";
};